import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDatas } from '../../../../services/axiosInstanceService';

/**
 * Fetches the total number of ads and new ads for a list of active research IDs.
 *
 * @param {Object} params - The parameters for the request.
 * @param {string[]} params.ids - An array of active research IDs to fetch ad counts for.
 * @returns {Promise<TotalNewAdsThunkResult>} A promise resolving to an array of objects containing
 *          the ID, total ads count, and total new ads count.
 */
const fetchActiveResearchesTotalAdsThunk = createAsyncThunk(
  'activeResearch/fetchActiveResearchesTotalAdsThunk',
  async (params: { ids: string[] }) => {
    try {
      // Ensure that IDs are provided
      if (!params.ids) throw new Error('No ids found');

      // Generate API endpoints for each ID
      const urls = params.ids.map((m) => `${m}/total-ads`);

      // Fetch data from all generated URLs concurrently
      const result = await Promise.all(urls.map((m) => fetchDatas(m)));

      // Parse and structure the response data
      const parsed: TotalNewAdsThunkResult = params.ids.map((id, i) => ({
        id, // Research ID
        totalAds: result[i].total_ads, // Total number of ads
        totalNewAds: result[i].total_new_ads, // Total number of new ads
      }));

      return parsed;
    } catch (error: any) {
      // Reject promise in case of an error
      return Promise.reject(error);
    }
  },
);

export default fetchActiveResearchesTotalAdsThunk;
